const MOVE_FROM_EWT_TO_CONNECTION = 'MOVE_FROM_EWT_TO_CONNECTION';

const initialState = {
    ewt: {
    qclocntSrl: null,
    ewtCode: "",
    ewtName: "",
    activeFlag: "Y",
    insUserSrl: 7563,
    insDate: new Date(),
  }
  };

  export const ewtReducer = (state = initialState, action) => {
    switch (action.type) {
      case MOVE_FROM_EWT_TO_CONNECTION:
  
              return { ...state, ewt: action.payload };
      default:
        return state;
    }
  };

  export const ewtActions={

    MoveFromEwtToConnection: (item) =>({type: MOVE_FROM_EWT_TO_CONNECTION,payload: item})
      };